// /**
//  * Keywords are placed in comments beside these definitions to help with searching
//  */

export type IconName =
  | 'account'
  | 'mentalHealth'
  | 'accountBoxOutline'
  | 'libraryArtefact'
  | 'testDocument'
  | 'testNote'
  | 'accountGroupOutline'
  | 'accountHeartOutline'
  | 'accountOutline'
  | 'accountSearchOutline'
  | 'multiDay'
  | 'apps'
  | 'add'
  | 'addAppointment'
  | 'addPatient'
  | 'alertDecagramOutline'
  | 'arrowExpand'
  | 'arrowCollapse'
  | 'appointmentIcon'
  | 'exercise'
  | 'arrowExpandHorizontal'
  | 'aspectRatio'
  | 'badgeAccountOutline'
  | 'bellBadgeOutline'
  | 'bellOutline'
  | 'bin'
  | 'battery_10'
  | 'battery_20'
  | 'battery_30'
  | 'battery_40'
  | 'battery_50'
  | 'battery_60'
  | 'battery_70'
  | 'battery_80'
  | 'battery_90'
  | 'battery_100'
  | 'binForever'
  | 'bookOpenPageVariantOutline'
  | 'bottleTonicOutline'
  | 'brain'
  | 'bullseyeArrow'
  | 'builder'
  | 'calendar'
  | 'camera'
  | 'cameraRotate'
  | 'cameraVideo'
  | 'calendarMulti'
  | 'loadIndicator'
  | 'cancel'
  | 'check'
  | 'chat'
  | 'chevronDown'
  | 'chevronLeft'
  | 'chevronRight'
  | 'chevronUp'
  | 'clinicianProfile'
  | 'cliniciansList'
  | 'clipboardAccountOutline'
  | 'clipboardEditOutline'
  | 'clock'
  | 'clockOff'
  | 'contentCopy'
  | 'cross'
  | 'dashboard'
  | 'desktopClassic'
  | 'document'
  | 'dosePlus'
  | 'dragVertical'
  | 'email'
  | 'emailAlert'
  | 'enlVideo'
  | 'exercises'
  | 'favouriteAdd'
  | 'favouriteRemove'
  | 'female'
  | 'flagOutline'
  | 'file'
  | 'fileReporting'
  | 'genderOther'
  | 'hamburgerMenu'
  | 'hangUp'
  | 'healthAndActivity'
  | 'healthIssues'
  | 'heart'
  | 'home'
  | 'hours24'
  | 'humanMaleHeightVariant'
  | 'information'
  | 'link'
  | 'location'
  | 'login'
  | 'logoutVariant'
  | 'magnify'
  | 'male'
  | 'mapMarker'
  | 'medicalBag'
  | 'messageAlert'
  | 'messageOutline'
  | 'mic'
  | 'micOff'
  | 'myDayOff'
  | 'myDayOn'
  | 'myDiaryCalendar'
  | 'myHealth'
  | 'notebookOutline'
  | 'nutritionalHealth'
  | 'tablets'
  | 'openInNew'
  | 'pencil'
  | 'pendingAppointment'
  | 'picture'
  | 'phone'
  | 'play'
  | 'profile'
  | 'quickAction'
  | 'refresh'
  | 'rotate360'
  | 'scaleBathroom'
  | 'diet'
  | 'screenRotate'
  | 'search'
  | 'send'
  | 'settings'
  | 'shrinkVideo'
  | 'target'
  | 'timerSandEmpty'
  | 'videoOff'
  | 'walk'
  | 'test'
  | 'mental'
  | 'websiteInternet'
  | 'zoomIn'
  | 'zoomOut'
  | 'allItems'
  | 'team'
  | 'patientCommunications'
  | 'consult'
  | 'alert'
  | 'documentEdit'
  | 'diagnosis'
  | 'flagIcon'
  | 'keyMetrics'
  | 'activityMonitor'
  | 'treatmentPlanCalendar'
  | 'injection'
  | 'favouriteStar'
  | 'dosage';

export type IconPath =
  | 'mdi-export-variant'
  | 'mdi-translate'
  | 'mdi-information-outline'
  | 'mdi-close'
  | 'mdi-chevron-right'
  | 'mdi-chevron-down'
  | 'mdi-account-multiple-plus-outline'
  | 'mdi-clock-outline'
  | 'mdi-phone'
  | 'mdi-arrow-collapse-down'
  | 'mdi-arrow-collapse-up'
  | 'mdi-phone-hangup'
  | 'mdi-video-off'
  | 'mdi-video'
  | 'mdi-microphone-off'
  | 'mdi-microphone'
  | 'mdi-download'
  | 'mdi-code-json'
  | 'mdi-stethoscope'
  | '360-rotate'
  | 'add-appointment'
  | 'add-patient'
  | 'add'
  | 'diet'
  | 'test'
  | 'mental'
  | 'appointment-icon'
  | 'bin'
  | 'builder'
  | 'calendar'
  | 'camera-rotate'
  | 'camera-video'
  | 'camera'
  | 'chat'
  | 'check'
  | 'chevron-down'
  | 'load-indicator'
  | 'calendar-multi'
  | 'chevron-left'
  | 'chevron-right'
  | 'multi-day'
  | 'chevron-up'
  | 'clinician-profile'
  | 'clinicians-list'
  | 'clock'
  | 'cross' // close
  | 'dashboard'
  | 'tablets'
  | 'document'
  | 'dose-plus'
  | 'email-alert'
  | 'email'
  | 'enl-video' // enlarge expand
  | 'exercises'
  | 'female'
  | 'file'
  | 'file-reporting'
  | 'gender-other'
  | 'hamburger-menu'
  | 'hang-up'
  | 'health-and-activity'
  | 'health-issues'
  | 'home'
  | 'information'
  | 'location'
  | 'male'
  | 'mdi-arrow-collapse'
  | 'mdi-arrow-expand'
  | 'mdi-format-list-checks'
  | 'mdi-account-box-outline'
  | 'mdi-account-group-outline'
  | 'mdi-account-heart-outline'
  | 'mdi-account-outline'
  | 'mdi-account-search-outline'
  | 'mdi-play'
  | 'mdi-account'
  | 'mdi-alarm-off'
  | 'mdi-alert-decagram-outline'
  | 'mdi-arrow-expand-horizontal'
  | 'mdi-aspect-ratio'
  | 'mdi-badge-account-outline'
  | 'mdi-bell-badge-outline'
  | 'mdi-bell-outline'
  | 'mdi-window-close'
  | 'mdi-square'
  | 'mdi-book-open-page-variant-outline'
  | 'mdi-bottle-tonic-plus-outline'
  | 'mdi-brain'
  | 'mdi-bullseye-arrow'
  | 'mdi-cancel'
  | 'mdi-battery-10'
  | 'mdi-battery-20'
  | 'mdi-battery-30'
  | 'mdi-battery-40'
  | 'mdi-battery-50'
  | 'mdi-battery-60'
  | 'mdi-battery-70'
  | 'mdi-battery-80'
  | 'mdi-battery-90'
  | 'mdi-battery-100'
  | 'mdi-clipboard-account-outline'
  | 'mdi-clipboard-edit-outline'
  | 'mdi-content-copy'
  | 'mdi-delete-forever'
  | 'mdi-desktop-classic'
  | 'mdi-drag-vertical'
  | 'mdi-flag-outline'
  | 'mdi-heart'
  | 'mdi-hours-24'
  | 'mdi-human-male-height-variant'
  | 'mdi-link'
  | 'mdi-login'
  | 'mdi-logout-variant'
  | 'mdi-magnify'
  | 'mdi-map-marker-outline'
  | 'mdi-medical-bag'
  | 'mdi-message-alert'
  | 'mdi-message-outline'
  | 'mdi-notebook-outline'
  | 'mdi-open-in-new'
  | 'mdi-scale-bathroom'
  | 'mdi-star-minus'
  | 'mdi-star-plus'
  | 'mdi-target'
  | 'mdi-timer-sand-empty'
  | 'mdi-walk'
  | 'mic-off'
  | 'mic'
  | 'my-day-dn'
  | 'my-day-off'
  | 'my-diary-calendar'
  | 'my-health'
  | 'nutritional-health'
  | 'pencil'
  | 'pending-appointment'
  | 'phone'
  | 'picture'
  | 'profile'
  | 'quick-action'
  | 'refresh'
  | 'screenRotate'
  | 'exercise'
  | 'search'
  | 'send'
  | 'settings'
  | 'shrink-video'
  | 'video-off'
  | 'website-internet'
  | 'zoom-in'
  | 'zoom-out'
  | 'mental-health'
  | 'library-artefact'
  | 'test-document'
  | 'test-note'
  | 'all-items-rectangle'
  | 'team'
  | 'patient-communications'
  | 'consult'
  | 'alert'
  | 'document-edit'
  | 'diagnosis'
  | 'flag'
  | 'key-metrics'
  | 'activity-monitor'
  | 'treatment-plan-calendar'
  | 'injection'
  | 'mdi-apps'
  | 'favourite-star'
  | 'dosage';

/**
 * Keywords are placed in comments beside these definitions to help with searching
 */
export const IconMap: Record<IconName, IconPath> = {
  apps: 'mdi-apps',
  testDocument: 'test-document',
  testNote: 'test-note',
  mentalHealth: 'mental-health',
  rotate360: '360-rotate',
  libraryArtefact: 'library-artefact',
  add: 'add',
  addAppointment: 'add-appointment',
  addPatient: 'add-patient',
  appointmentIcon: 'appointment-icon',
  accountBoxOutline: 'mdi-account-box-outline',
  accountGroupOutline: 'mdi-account-group-outline',
  accountSearchOutline: 'mdi-account-search-outline',
  account: 'mdi-account',
  accountOutline: 'mdi-account-outline',
  alertDecagramOutline: 'mdi-alert-decagram-outline',
  accountHeartOutline: 'mdi-account-heart-outline',
  arrowExpandHorizontal: 'mdi-arrow-expand-horizontal',
  aspectRatio: 'mdi-aspect-ratio',
  bin: 'bin',
  badgeAccountOutline: 'mdi-badge-account-outline',
  binForever: 'mdi-delete-forever',
  loadIndicator: 'load-indicator',
  bellOutline: 'mdi-bell-outline',
  exercise: 'exercise',
  multiDay: 'multi-day',
  bellBadgeOutline: 'mdi-bell-badge-outline',
  bullseyeArrow: 'mdi-bullseye-arrow',
  builder: 'builder',
  bottleTonicOutline: 'mdi-bottle-tonic-plus-outline',
  bookOpenPageVariantOutline: 'mdi-book-open-page-variant-outline',
  brain: 'mdi-brain',
  calendar: 'calendar',
  cancel: 'mdi-cancel',
  chat: 'chat',
  camera: 'camera',
  cameraRotate: 'camera-rotate',
  cameraVideo: 'camera-video',
  check: 'check',
  chevronDown: 'chevron-down',
  chevronUp: 'chevron-up',
  chevronLeft: 'chevron-left',
  tablets: 'tablets',
  chevronRight: 'chevron-right',
  clinicianProfile: 'clinician-profile',
  cliniciansList: 'clinicians-list',
  clock: 'clock',
  calendarMulti: 'calendar-multi',
  contentCopy: 'mdi-content-copy',
  clockOff: 'mdi-alarm-off',
  clipboardEditOutline: 'mdi-clipboard-edit-outline',
  clipboardAccountOutline: 'mdi-clipboard-account-outline',
  cross: 'cross', // close
  dashboard: 'dashboard',
  desktopClassic: 'mdi-desktop-classic',
  document: 'document',
  dosePlus: 'dose-plus',
  dragVertical: 'mdi-drag-vertical',
  email: 'email',
  emailAlert: 'email-alert',
  enlVideo: 'enl-video', // enlarge expand
  exercises: 'exercises',
  favouriteRemove: 'mdi-star-minus',
  favouriteAdd: 'mdi-star-plus',
  battery_10: 'mdi-battery-10',
  battery_20: 'mdi-battery-20',
  battery_30: 'mdi-battery-30',
  battery_40: 'mdi-battery-40',
  battery_50: 'mdi-battery-50',
  battery_60: 'mdi-battery-60',
  battery_70: 'mdi-battery-70',
  battery_80: 'mdi-battery-80',
  battery_90: 'mdi-battery-90',
  battery_100: 'mdi-battery-100',
  female: 'female',
  flagOutline: 'mdi-flag-outline',
  file: 'file',
  fileReporting: 'file-reporting',
  genderOther: 'gender-other',
  hamburgerMenu: 'hamburger-menu',
  hangUp: 'hang-up',
  healthAndActivity: 'health-and-activity',
  healthIssues: 'health-issues',
  home: 'home',
  diet: 'diet',
  test: 'test',
  mental: 'mental',
  heart: 'mdi-heart',
  hours24: 'mdi-hours-24',
  humanMaleHeightVariant: 'mdi-human-male-height-variant',
  information: 'information',
  location: 'location',
  login: 'mdi-login',
  link: 'mdi-link',
  logoutVariant: 'mdi-logout-variant',
  male: 'male',
  magnify: 'mdi-magnify',
  mic: 'mic',
  micOff: 'mic-off',
  myDayOff: 'my-day-off',
  myDayOn: 'my-day-dn',
  medicalBag: 'mdi-medical-bag',
  messageOutline: 'mdi-message-outline',
  myDiaryCalendar: 'my-diary-calendar',
  myHealth: 'my-health',
  mapMarker: 'mdi-map-marker-outline',
  messageAlert: 'mdi-message-alert',
  nutritionalHealth: 'nutritional-health',
  notebookOutline: 'mdi-notebook-outline',
  openInNew: 'mdi-open-in-new',
  arrowExpand: 'mdi-arrow-expand',
  arrowCollapse: 'mdi-arrow-collapse',
  pencil: 'pencil',
  pendingAppointment: 'pending-appointment',
  phone: 'phone',
  picture: 'picture',
  play: 'mdi-play',
  profile: 'profile',
  quickAction: 'quick-action',
  refresh: 'refresh',
  screenRotate: 'screenRotate',
  search: 'search',
  send: 'send',
  settings: 'settings',
  shrinkVideo: 'shrink-video',
  scaleBathroom: 'mdi-scale-bathroom',
  target: 'mdi-target',
  timerSandEmpty: 'mdi-timer-sand-empty',
  videoOff: 'video-off',
  websiteInternet: 'website-internet',
  walk: 'mdi-walk',
  zoomIn: 'zoom-in',
  zoomOut: 'zoom-out',
  allItems: 'all-items-rectangle',
  diagnosis: 'diagnosis',
  team: 'team',
  patientCommunications: 'patient-communications',
  consult: 'consult',
  alert: 'alert',
  documentEdit: 'document-edit',
  flagIcon: 'flag',
  keyMetrics: 'key-metrics',
  activityMonitor: 'activity-monitor',
  treatmentPlanCalendar: 'treatment-plan-calendar',
  injection: 'injection',
  favouriteStar: 'favourite-star',
  dosage: 'dosage'
};
